import { classNames } from '@vkontakte/vkui';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SHARING_VARIANT } from 'reactApp/components/SharingWindow/blocks/Weblink/WeblinkList/SharingNewWeblinkList.types';
import { User } from 'reactApp/components/SharingWindow/ui/User/User';
import type { IACListItem } from 'reactApp/modules/folderAccessControlList/folderAccessControlList.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { Loader } from 'reactApp/ui/Loader/Loader';

import styles from './UserList.css';
import type { IProps } from './UserList.types';

export const UserList = React.memo(function UserList({
    acList,
    isLoading,
    isMounted,
    isSharedIncoming,
    owner,
    isPhone,
    item,
    compact = false,
    onClose,
    variant = SHARING_VARIANT.default,
}: IProps) {
    const name = owner?.name || '';
    const email = name ? ` (${owner?.email})` : owner?.email;
    const isReadOnlyItem = !!item?.isReadOnly;
    const currentUserEmail = useSelector(UserSelectors.getEmail);

    const renderItem = useCallback(
        (user) => (
            <div className={classNames(styles.user)} key={user.email}>
                <User
                    user={user}
                    item={item}
                    isMounted={isMounted}
                    currentUserEmail={currentUserEmail}
                    onClose={onClose}
                    publicId={item?.weblink}
                    isPhone={isPhone}
                    variant={variant}
                />
            </div>
        ),
        [currentUserEmail, isMounted, item, onClose, isPhone, variant]
    );

    return (
        <div
            className={classNames(styles.root, {
                [styles.root_phone]: isPhone,
                [styles.mounted]: isSharedIncoming,
                [styles.root_tabs]: variant === SHARING_VARIANT.folders || variant === SHARING_VARIANT.foldersBiz,
            })}
        >
            {isMounted && owner && (
                <div className={styles.mountedRights}>
                    <span>
                        {name}
                        {email}
                    </span>{' '}
                    предоставил вам доступ на
                    {isReadOnlyItem ? ' чтение' : ' редактирование'}
                </div>
            )}
            <div
                className={classNames(styles.usersList, {
                    [styles.usersList_scroll]: !isMounted && acList.length > 4,
                    [styles.compact]: compact,
                })}
            >
                {isLoading ? (
                    <div className={styles.loading}>
                        <Loader centered isModal />
                    </div>
                ) : (
                    <>
                        {Boolean(owner) && (
                            <div className={classNames(styles.user)}>
                                <User
                                    currentUserEmail={currentUserEmail}
                                    user={owner as IACListItem}
                                    isPhone={isPhone}
                                    isOwner
                                    variant={variant}
                                />
                            </div>
                        )}
                        {acList.map((user) => renderItem(user))}
                    </>
                )}
            </div>
        </div>
    );
});
